import { create } from 'zustand';
import { IWhitelabelState, IWhitelabelStore } from './types';
import { institutionsApi } from '@/API';
import { convertKeys } from '@/utils/common';

const initialState: IWhitelabelState = {
  currentWhitelabel: null,
  institutions: [],
};

export const useWhitelabelStore = create<IWhitelabelStore>((set, get) => ({
  ...initialState,
  setCurrentWhitelabelById: (id) => {
    const result = get().institutions.find((item) => item.id === id) ?? null;
    set({ currentWhitelabel: result });
  },
  setCurrentWhitelabelBySubdomain: (subdomain) => {
    const result =
      get().institutions.find(
        (item) =>
          item?.whitelabel?.subdomain?.toLowerCase() ===
            subdomain?.toLowerCase() && item?.whitelabel?.enabled,
      ) ?? null;
    if (!result) return;
    set({ currentWhitelabel: result });
  },
  getInstitutionsWhitelabel: async (isAuth) => {
    try {
      const res = isAuth
        ? await institutionsApi.getInstitutions()
        : await institutionsApi.getInstitutionsNotSigned();
      const institutions = convertKeys(res.data.data);
      set({ institutions });
      return institutions;
    } catch (error) {
      console.error(error);
      return [];
    }
  },
  clearWhitelabelStore: () => set(initialState),
}));
